import {
  SET_ADDITIONAL_PARAMS,
  SET_SUBSCRIPTION_FREQUENCY,
  SET_SUBSCRIPTION_TYPES,
} from "../actions/actionTypes";

const initialState = {
  additionalParams: null,
  subscriptionFrequency: null,
  subscriptionTypes: null,
};
export default function subscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ADDITIONAL_PARAMS:
      return {
        ...state,
        additionalParams: action.payload,
      };

    case SET_SUBSCRIPTION_FREQUENCY:
      return {
        ...state,
        subscriptionFrequency: action.payload,
      };

    case SET_SUBSCRIPTION_TYPES:
      return {
        ...state,
        subscriptionTypes: action.payload,
      };

    default:
      return state;
  }
}

//
// export default function userReducer(
//   state = initialState.userReducerState,
//   action
// ) {
//   switch (action.type) {
//     case USER_REGISTRATION_IS_LOADING: {
//       return {
//         ...state,
//         userRegistrationIsLoading: action.userRegistrationIsLoading,
//         userRegistrationIsLoadedWithError: false,
//         user: {},
//         loggedIn: false,
//       };
//     }

//     case USER_REGISTRATION_IS_LOADED_WITH_ERROR: {
//       return {
//         ...state,
//         userRegistrationIsLoading: false,
//         userRegistrationIsLoadedWithError: true,
//         userRegistrationErrorMessage: action.userRegistrationErrorMessage,
//         user: {},
//         loggedIn: false,
//       };
//     }

//     case USER_REGISTRATION_IS_LOADED: {
//       return {
//         ...state,
//         userRegistrationIsLoading: false,
//         userRegistrationIsLoadedWithError: false,
//         userRegistrationSuccessMessage: action.userRegistrationSuccessMessage,
//         workspacesOfUser: action.workspacesOfUser,
//         user: {},
//         loggedIn: false,
//       };
//     }

//     case USER_LOGGING_IS_LOADING: {
//       return {
//         ...state,
//         userLoggingIsLoading: action.userLoggingIsLoading,
//         userLoggingIsLoadedWithError: false,
//         user: {},
//         loggedIn: false,
//       };
//     }

//     case USER_LOGGING_IS_LOADED_WITH_ERROR: {
//       return {
//         ...state,
//         userLoggingIsLoading: false,
//         userLoggingIsLoadedWithError: true,
//         userLoggingErrorMessage: action.userLoggingErrorMessage,
//         user: {},
//         loggedIn: false,
//       };
//     }

//     case USER_LOGGING_IS_LOADED: {
//       return {
//         ...state,
//         userLoggingIsLoading: false,
//         userLoggingIsLoadedWithError: false,
//         user: action.user,
//         workspacesOfUser: action.workspacesOfUser,
//         loggedIn: true,
//       };
//     }

//     case CURATED_REGHUB_TOPICS_HAVE_LOADED: {
//       return {
//         ...state,
//         userToken: action.userToken,
//       };
//     }

//     case USER_LOGGED_OUT: {
//       return {
//         ...state,
//         userRegistrationIsLoading: false,
//         userRegistrationIsLoadedWithError: false,
//         userRegistrationErrorMessage: "",
//         userRegistrationSuccessMessage: "",
//         user: {},
//         loggedIn: false,
//       };
//     }

//     case CHECK_USER_RIGHTS: {
//       return {
//         ...state,
//         userRights: action.userRights,
//       };
//     }

//     default: {
//       return state;
//     }
//   }
// }
